import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2784dd2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card py-5 px-5" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "card mt-5"
}
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-body py-4" }
const _hoisted_10 = {
  class: "table align-middle table-row-dashed fs-5 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_11 = { class: "text-start table-header-text fw-bold fs-5 text-uppercase gs-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "cell-color text-center" }
const _hoisted_15 = { class: "cell-color text-center" }
const _hoisted_16 = {
  key: 1,
  class: "cell-color text-center"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "d-flex align-items-center gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "cell-color text-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-up-from-bracket" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "cell-color text-center" }
const _hoisted_35 = { class: "cell-color" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "d-flex justify-content-center fs-1 mb-5" }
const _hoisted_39 = {
  class: "d-flex justify-content-center fs-1 pt-3 pb-3",
  style: {"background-color":"cornsilk","border-radius":"100px"}
}
const _hoisted_40 = { class: "mt-9 d-flex justify-content-center" }
const _hoisted_41 = {
  key: 0,
  class: "tip fs-8 badge badge-light"
}

import MsgPrompt from "@/core/plugins/MsgPrompt";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import UploadDepositReceiptModal from "../modal/UploadDepositReceiptModal.vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import DepositReference from "@/projects/tenant/modules/Payment/modal/DepositReference.vue";
import HeaderMenu from "../components/HeaderMenu.vue";
import { ActionType } from "@/core/types/Actions";
import { ref, onMounted, inject, watch, reactive, provide } from "vue";
import { CommentType } from "@/core/types/CommentType";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import TinyCopyBox from "@/components/TinyCopyBox.vue";
import TenantGlobalService, {
  CreateReportSpec,
} from "@/projects/tenant/services/TenantGlobalService";
import {
  TransactionStateType,
  DepositStatusType,
  DepositStateTypes,
} from "@/core/types/StateInfos";
import {
  PaymentStatusTypes,
  PaymentPlatformTypes,
} from "@/core/types/PaymentTypes";
import i18n from "@/core/plugins/i18n";
import Decimal from "decimal.js";
import { convertTradeTime } from "@/core/helpers/helpers";
import { Document } from "@element-plus/icons-vue";
import HistoryRecord from "../components/modal/HistoryRecord.vue";
import Clipboard from "clipboard";

import Can from "@/core/plugins/ICan";

export default /*#__PURE__*/_defineComponent({
  __name: 'DepositIndex',
  setup(__props) {

const historyRef = ref<any>(null);

const showTip = ref(false);
const t = i18n.global.t;
const isLoading = ref(false);
provide("isLoading", isLoading);
const callBackLoading = ref(false);
const dealingDataLoading = ref(false);
const exporting = ref(false);

const TabStatus = DepositStatusType;
const tab = ref<any>(TabStatus.Pending);
const headerMenuRef = ref<InstanceType<typeof HeaderMenu>>();
const data = ref(<any>[]);
const dataDealing = ref(<any>[]);
const callBackData = ref(<any>[]);

const period = ref([] as any);
const showAddress = ref(false);
const dialogData = ref(<any>[]);

const commentsRef = ref<InstanceType<typeof CommentsView>>();
const depositReferenceRef = ref<InstanceType<typeof DepositReference>>();
const uploadDepositReceiptRef =
  ref<InstanceType<typeof UploadDepositReceiptModal>>();

const criteria = ref<any>({
  page: 1,
  size: 10,
  stateId: tab.value,
  sortField: "createdOn",
});

const dealingCriteria = ref<any>({
  page: 1,
  size: 10,
  stateIds: [
    TransactionStateType.DepositPaymentCompleted,
    TransactionStateType.DepositCallbackTimeOut,
  ],
  sortField: "createdOn",
});

const callBackCriteria = ref<any>({
  page: 1,
  size: 10,
  stateId: TransactionStateType.DepositCallbackComplete,
  sortField: "createdOn",
});

const changeTab = (_tab: any) => {
  tab.value = _tab;
  if (tab.value == TabStatus.All) {
    criteria.value.stateId = null;
  } else criteria.value.stateId = tab.value;
  fetchAll();
};

const fetchAll = (page?: number) => {
  const pageNumber = page ?? 1;
  if (tab.value == TabStatus.Pending) {
    fetchData(pageNumber);
    fetchDealingData(pageNumber);
    fetchCallBackData(pageNumber);
  } else {
    fetchData(pageNumber);
  }
};

const actualAmount = (amount: any) => {
  return new Decimal(amount)
    .div(100)
    .toFixed(0)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const fetchData = async (_page?: number) => {
  if (_page) criteria.value.page = _page;

  isLoading.value = true;
  try {
    const res = await PaymentService.queryDeposits(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.error("Error fetching deposit data:", error);
    // 如果发生错误，设置空数据
    data.value = [];
    criteria.value = {
      ...criteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
    // 可以选择显示错误提示
    // MsgPrompt.error("Failed to fetch deposit data");
  } finally {
    isLoading.value = false;
  }
};

const fetchDealingData = async (_page?: number) => {
  if (_page) dealingCriteria.value.page = _page;

  dealingDataLoading.value = true;
  try {
    const res = await PaymentService.queryDeposits(dealingCriteria.value);
    dealingCriteria.value = res.criteria;
    dataDealing.value = res.data;
  } catch (error) {
    console.error("Error fetching dealing data:", error);
    dataDealing.value = [];
    dealingCriteria.value = {
      ...dealingCriteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    dealingDataLoading.value = false;
  }
};

const fetchCallBackData = async (_page?: number) => {
  if (_page) callBackCriteria.value.page = _page;

  callBackLoading.value = true;
  try {
    const res = await PaymentService.queryDeposits(callBackCriteria.value);
    callBackCriteria.value = res.criteria;
    callBackData.value = res.data;
  } catch (error) {
    console.error("Error fetching callback data:", error);
    callBackData.value = [];
    callBackCriteria.value = {
      ...callBackCriteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    callBackLoading.value = false;
  }
};

const dataColection = reactive(<any>[
  {
    label: "財務部門 審核",
    show: true,
    data: data,
    isLoading: isLoading,
    fetchData: fetchData,
    criteria: criteria,
  },
  {
    label: "Dealing 審核",
    show: TabStatus.Pending,
    data: dataDealing,
    isLoading: dealingDataLoading,
    fetchData: fetchDealingData,
    criteria: dealingCriteria,
  },
  {
    label: "第三方 - 完成支付",
    show: TabStatus.Pending,
    data: callBackData,
    isLoading: callBackLoading,
    fetchData: fetchCallBackData,
    criteria: callBackCriteria,
  },
]);

watch(
  () => period.value,
  (periodVal) => {
    if (periodVal && periodVal.length > 0) {
      const [from, to] = convertTradeTime(periodVal[0], periodVal[1]);
      criteria.value.from = from;
      criteria.value.to = to;
    } else {
      criteria.value.from = null;
      criteria.value.to = null;
    }
  }
);
const confirmSearch = () => {
  if (tab.value != TabStatus.All) {
    headerMenuRef.value?.changeTab(TabStatus.All);
  } else {
    fetchData(1);
  }
};

const clearSearchFilterCriteria = () => {
  criteria.value = {
    page: 1,
    size: 10,
    SortField: "updatedOn",
    stateId: tab.value,
  };
  if (tab.value == TabStatus.All) {
    criteria.value.stateId = null;
  }
  period.value = [];
  fetchAll();
};

const openUploadDepositReceiptPanel = (_id: number) => {
  uploadDepositReceiptRef.value?.show(_id);
};

const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};

const formData = ref<CreateReportSpec>({
  name: "",
  type: ReportRequestTypes.DepositForTenant,
  query: criteria.value,
});

const submitReportRequest = async () => {
  exporting.value = true;
  const [from, to] = period.value ?? [null, null];
  const [createdFrom, createdTo] = convertTradeTime(from, to);

  formData.value.query = {
    from: createdFrom,
    to: createdTo,
    stateId: criteria.value.stateId,
  };
  try {
    const media = await TenantGlobalService.createReportRequestDownload(
      formData.value
    );
    await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    exporting.value = false;
  }
};
const viewPoliReference = async (id) => {
  const res = await PaymentService.getDepositReferenceById(id);
  depositReferenceRef.value?.show(res);
};

const openFilePreviewModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_FILE_MODAL
);

const viewWireReceipt = async (id) => {
  const res = await PaymentService.getDepositReceiptById(id);
  const media = {
    guid: res[0],
  };
  openFilePreviewModal?.(media);
};

const getTagType = (status: number) => {
  switch (status) {
    case PaymentStatusTypes.Pending:
      return "primary";
    case PaymentStatusTypes.Completed:
      return "success";
    case PaymentStatusTypes.Failed:
      return "danger";
    case PaymentStatusTypes.Executing:
      return "warning";
    default:
      return "primary";
  }
};

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);
const openConfirmPanel = (
  _action: ActionType,
  id: number,
  paymentID?: number
) => {
  openConfirmModal?.(() => {
    return {
      [ActionType.Approve]: () => PaymentService.approveDepositById(id),
      [ActionType.Reject]: () => PaymentService.rejectDepositById(id),
      [ActionType.Cancel]: () => PaymentService.cancelDepositById(id),
      [ActionType.CompletePayment]: () =>
        PaymentService.completeDepositByPaymentId(id),
      [ActionType.Complete]: () =>
        PaymentService.completeCallBackByPaymentId(id),
      [ActionType.RestoreRejected]: () =>
        PaymentService.restoreRejectedDepositByPaymentId(id),
      [ActionType.RestoreCanceled]: () =>
        PaymentService.restoreCanceledDepositByPaymentId(id),
    }
      [_action]()
      .then(() => {
        fetchAll(criteria.value.page);
      });
  });
};

const buttonTypes = {
  comepletePayment: (item) => ({
    label: t("action.completePayment"),
    type: "btn-info",
    action: () => openConfirmPanel(ActionType.CompletePayment, item.id),
  }),
  approvePayment: (item) => ({
    label: t("action.approve"),
    type: "btn-primary",
    action: () => openConfirmPanel(ActionType.Approve, item.id),
  }),
  rejectPayment: (item) => ({
    label: t("action.reject"),
    type: "btn-danger",
    action: () => openConfirmPanel(ActionType.Reject, item.id),
  }),
  cancelPayment: (item) => ({
    label: t("action.cancel"),
    type: "btn-light-danger",
    action: () => openConfirmPanel(ActionType.Cancel, item.id),
  }),
  restoreRejectPayment: (item) => ({
    label: t("action.restore"),
    type: "btn-light-danger",
    action: () => openConfirmPanel(ActionType.RestoreRejected, item.id),
  }),
  restoreCancelPayment: (item) => ({
    label: t("action.restore"),
    type: "btn-light-danger",
    action: () => openConfirmPanel(ActionType.RestoreCanceled, item.id),
  }),
  completeCallbackPayment: (item) => ({
    label: t("action.complete"),
    type: "btn-info",
    action: () => openConfirmPanel(ActionType.Complete, item.id),
  }),
};
const $cans = Can.cans;

function getButtons(item: any) {
  let configs: any[] = [];

  switch (item.stateId) {
    case TransactionStateType.DepositCreated:
      configs.push(buttonTypes["comepletePayment"](item));
      configs.push(buttonTypes["cancelPayment"](item));
      break;

    case TransactionStateType.DepositPaymentCompleted:
      configs.push(buttonTypes["approvePayment"](item));
      if ($cans(["TenantAdmin"])) {
        configs.push(buttonTypes["rejectPayment"](item));
      }
      break;

    case TransactionStateType.DepositCallbackTimeOut:
      configs.push(buttonTypes["approvePayment"](item));
      if ($cans(["TenantAdmin"])) {
        configs.push(buttonTypes["rejectPayment"](item));
      }
      break;

    case TransactionStateType.DepositTenantRejected:
      configs.push(buttonTypes["restoreRejectPayment"](item));
      break;

    case TransactionStateType.DepositCanceled:
      configs.push(buttonTypes["restoreCancelPayment"](item));
      break;

    case TransactionStateType.DepositCallbackComplete:
      configs.push(buttonTypes["completeCallbackPayment"](item));
      configs.push(buttonTypes["cancelPayment"](item));
      break;
  }
  return configs;
}

const showWalletAddress = (_walletAddress: any) => {
  showAddress.value = true;
  dialogData.value = _walletAddress;
};

const copyAddress = (_walletAddress) => {
  Clipboard.copy(_walletAddress as string);
  showTip.value = true;
  setTimeout(() => {
    showTip.value = false;
  }, 1000);
};

onMounted(() => {
  fetchAll();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderMenu, {
        tabs: _unref(TabStatus),
        onChangeTab: changeTab,
        ref_key: "headerMenuRef",
        ref: headerMenuRef
      }, null, 8, ["tabs"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_date_picker, {
              class: "w-250px",
              modelValue: period.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
              type: "daterange",
              "start-placeholder": _ctx.$t('fields.startDate'),
              "end-placeholder": _ctx.$t('fields.endDate'),
              disabled: isLoading.value,
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"]),
            (tab.value === _unref(TabStatus).All)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: criteria.value.stateId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.stateId) = $event)),
                  onChange: confirmSearch,
                  class: "w-150px",
                  placeholder: _ctx.$t('fields.status'),
                  clearable: "",
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: null,
                      label: _ctx.$t('fields.all')
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DepositStateTypes), (depositStatus) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: depositStatus,
                        value: depositStatus,
                        label: 
                _ctx.$t(`type.transactionState.${depositStatus}`).replace(
                  /^Deposit /,
                  ''
                )
              
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.accountNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.accountNumber) = $event)),
              class: "w-200px",
              placeholder: _ctx.$t('fields.accountNumber'),
              clearable: "",
              disabled: isLoading.value
            }, null, 8, ["modelValue", "placeholder", "disabled"]),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.email) = $event)),
              class: "w-250px ms-2",
              placeholder: _ctx.$t('fields.email'),
              clearable: "",
              disabled: isLoading.value
            }, null, 8, ["modelValue", "placeholder", "disabled"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              onClick: confirmSearch,
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              plain: "",
              onClick: clearSearchFilterCriteria,
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (tab.value === _unref(TabStatus).All)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "success",
                  onClick: submitReportRequest,
                  loading: exporting.value,
                  disabled: isLoading.value,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_5
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataColection, (data, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (tab.value == data.show || data.show == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(data.label), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_11, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                        (tab.value == _unref(TabStatus).All)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.status")), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentId")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentNo")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.actualAmount")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.exchangeRate")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.tradeAccount")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")), 1),
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.receipt")), 1),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
                        (tab.value != _unref(TransactionStateType).DepositCompleted)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(_ctx.$t("action.action")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (data.isLoading)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                          _createVNode(_component_LoadingRing)
                        ]))
                      : (!data.isLoading && data.data.length === 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                            _createVNode(_component_NoDataBox)
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_20, [
                                  (item.user)
                                    ? (_openBlock(), _createBlock(_component_UserInfo, {
                                        key: 0,
                                        user: item.user,
                                        class: "me-2"
                                      }, null, 8, ["user"]))
                                    : _createCommentVNode("", true)
                                ]),
                                (tab.value == _unref(TabStatus).All)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`).replace(
                      /^Deposit /,
                      ""
                    )), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_el_tag, {
                                      type: getTagType(item.payment.status),
                                      effect: "dark",
                                      class: "fs-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["type"]),
                                    _createVNode(_component_el_button, {
                                      icon: _unref(Document),
                                      circle: "",
                                      onClick: ($event: any) => (historyRef.value.show(item.id))
                                    }, null, 8, ["icon", "onClick"])
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.payment.id), 1),
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(item.payment.number.substring(3)) + " ", 1),
                                  _createVNode(TinyCopyBox, {
                                    val: item.payment.number.substring(3)
                                  }, null, 8, ["val"])
                                ]),
                                _createElementVNode("td", null, [
                                  (item.payment.paymentServiceName == 'USDT Crypto')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(item.walletAddress != '' ? 'cursor-pointer ' : ''),
                                        style: _normalizeStyle({
                      color: item.walletAddress != '' ? '#fd7e14' : 'black',
                    }),
                                        onClick: ($event: any) => (showWalletAddress(item.walletAddress))
                                      }, _toDisplayString(item.payment.referenceNumber), 15, _hoisted_23))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.payment.paymentServiceName), 1))
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_BalanceShow, {
                                    "currency-id": item.currencyId,
                                    balance: item.amount
                                  }, null, 8, ["currency-id", "balance"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(actualAmount(item.payment.amount)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.payment.exchangeRate), 1),
                                _createElementVNode("td", null, [
                                  (item.targetTradeAccount)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).Account,
                        item.targetTradeAccount.id,
                        item.targetTradeAccount.accountNumber
                      )
                    )
                                      }, [
                                        _createTextVNode(_toDisplayString(item.targetTradeAccount.accountNumber) + " ", 1),
                                        (item.targetTradeAccount.hasComment)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_25))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.targetTradeAccount.group), 1),
                                _createElementVNode("td", _hoisted_27, [
                                  _createVNode(_component_TimeShow, {
                                    "date-iso-string": item.payment.createdOn
                                  }, null, 8, ["date-iso-string"])
                                ]),
                                _createElementVNode("td", _hoisted_28, [
                                  (
                      item.payment.paymentServiceId == _unref(PaymentPlatformTypes).Poli
                    )
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "btn btn-sm btn-light-success fw-bold ms-2 fs-8 py-1 px-3",
                                        onClick: ($event: any) => (viewPoliReference(item.id))
                                      }, _toDisplayString(_ctx.$t("action.viewReference")), 9, _hoisted_29))
                                    : (item.hasReceipt)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          href: "#",
                                          class: "btn btn-sm btn-light-primary fw-bold ms-2 fs-8 py-1 px-3",
                                          onClick: ($event: any) => (viewWireReceipt(item.id))
                                        }, _toDisplayString(_ctx.$t("action.viewReceipt")), 9, _hoisted_30))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          onClick: ($event: any) => (openUploadDepositReceiptPanel(item.id)),
                                          style: {"cursor":"pointer"}
                                        }, _hoisted_33, 8, _hoisted_31))
                                ]),
                                _createElementVNode("td", _hoisted_34, _toDisplayString(item.operatorName), 1),
                                _createElementVNode("td", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getButtons(item), (button, index) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: index,
                                        class: _normalizeClass(["btn btn-sm me-3", button.type]),
                                        onClick: button.action
                                      }, _toDisplayString(button.label), 11, _hoisted_37))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                  ]),
                  _createVNode(_component_TableFooter, {
                    onPageChange: data.fetchData,
                    criteria: data.criteria
                  }, null, 8, ["onPageChange", "criteria"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(DepositReference, {
      ref_key: "depositReferenceRef",
      ref: depositReferenceRef
    }, null, 512),
    _createVNode(HistoryRecord, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512),
    _createVNode(UploadDepositReceiptModal, {
      ref_key: "uploadDepositReceiptRef",
      ref: uploadDepositReceiptRef,
      onFetchData: fetchData
    }, null, 512),
    _createVNode(CommentsView, {
      ref_key: "commentsRef",
      ref: commentsRef,
      type: "",
      id: "0"
    }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: showAddress.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showAddress).value = $event)),
      width: "700",
      "align-center": "",
      style: {"max-height":"95vh","overflow":"auto"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("action.deposit")) + " " + _toDisplayString(_ctx.$t("tip.walletAddress")), 1),
        _createElementVNode("div", _hoisted_39, _toDisplayString(dialogData.value), 1),
        _createElementVNode("div", _hoisted_40, [
          (showTip.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Copyed "))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            class: "text-gray cursor-pointer position-relative",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (copyAddress(dialogData.value)))
          }, {
            default: _withCtx(() => [
              (showTip.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["tip fs-8 badge badge-light", { 'show-tip-animation': showTip.value }])
                  }, "Copyed ", 2))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.$t("action.copy")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})